import { API_ADAPTERS, getAdapter } from '../config';

export function isTypeSerializable(type, api = API_ADAPTERS.CORE_API) {
  const adapter = getAdapter(api);
  return !!type && !!adapter.serializer.schemas[type];
}
